import { calculatePanel } from 'pu-data/Utils';

export const updatePanelSize = (parameters) => {
  const result = calculatePanel(parameters);
  if (result) {
    parameters.array_up = result.array_up;
    parameters.array_x = result.array_x;
    parameters.array_y = result.array_y;
  }
};

export default updatePanelSize;
